// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\"> <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M3.3333 11.6667h5v5m8.3334-8.3335h-5v-5m0 5.0001L17.5001 2.5M2.5 17.5001l5.8333-5.8334\"/> </svg>";
// Exports
module.exports = code;